






















































































import ListItemStep from '@/components/Steps/ListItemStep.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { ModuleHasEnvironment } from '@/interfaces/ModuleHasEnvironment';
import env from '@/env';
import { Step } from '@/interfaces/Step';
import { Module } from '@/interfaces/Module';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Environment } from '@/interfaces/Environment';
import AppSAPBadge from '@/components/App/AppSAPBadge.vue';

@Component({
  components: {
    AppSAPBadge,
    ListItemStep
  }
})
export default class ModuleCard extends Vue {
  @Prop()
  cutoverplan?: Cutoverplan;

  @Prop()
  module!: Module;

  @Prop()
  selectedEnvironment!: number;

  adjustedModule?: Module;

  @Watch('selectedEnvironment')
  watchSelectedEnvironment() {
    this.checkEnvironment();
  }

  mounted() {
    this.checkEnvironment();
  }

  getOverwriteStep(step: Step): Step | undefined {
    if (!this.selectedEnvironment) return {} as Step;
    return step.environments.find(
      (environment) => environment.environment_id === this.selectedEnvironment
    )?.change;
  }

  get listItemBackgroundColor() {
    if (!this.selectedEnvironment) {
      return '';
    }
    return `background-color:${
      this.$store.state.all_environments?.find(
        (environment: Environment) => environment.id === this.selectedEnvironment
      ).color
    }`;
  }

  get envSwitchValue() {
    const value = !this.module.environments.find(
      (e: ModuleHasEnvironment) => e.environment_id === this.selectedEnvironment
    )?.disabled;
    return value;
  }

  set envSwitchValue(value) {
    axios.post(`${env.backend_url}/module/toggle-environment/${this.module.id}`, {
      environment_id: this.selectedEnvironment,
      disabled: !value
    });

    const moduleEnvironment = this.module.environments.find(
      (e: ModuleHasEnvironment) => e.environment_id === this.selectedEnvironment
    );
    if (moduleEnvironment) {
      const index = this.module.environments.indexOf(moduleEnvironment);
      this.module.environments.splice(index, 1);
    }
    this.module.environments.push(({
      module_id: this.module.id,
      environment_id: this.selectedEnvironment,
      disabled: !value
    } as unknown) as ModuleHasEnvironment);
  }

  get envName() {
    return (
      this.$store.state.all_environments.find((e: Environment) => e.id === this.selectedEnvironment)
        ?.name || '?'
    );
  }

  get moduleLanguage() {
    const preferredLanguage = this.module.moduleLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage;
    return this.module.moduleLanguages?.[0];
  }

  get name() {
    return this.moduleLanguage?.name;
  }

  checkIfStepShouldBeCrossedOut(step: Step): string {
    const reasons: string[] = [];
    if (!this.cutoverplan) return '';
    const stepHasNoPhase = !step.phase_id;
    const stepPhaseNotInCutoverplan = !this.cutoverplan.phases?.find(
      (phase: any) => phase.phase_id === step.phase_id
    );

    if (stepHasNoPhase || stepPhaseNotInCutoverplan)
      reasons.push('Schritt ist einer Phase die nicht im Cutoverplan ist');

    const environmentStep = step.environments.find(
      (stepEnvironment) => stepEnvironment.environment_id === this.selectedEnvironment
    );
    if (this.selectedEnvironment && environmentStep && !environmentStep.enabled)
      reasons.push('Schritt ist für diese Umgebung deaktiviert');

    if (!this.envSwitchValue) reasons.push('Modul ist für diese Umgebung deaktiviert');

    return reasons.join('; ');
  }

  async checkEnvironment() {
    if (!this.selectedEnvironment) {
      this.adjustedModule = this.module;
    }
  }

  async toggleModuleEnvironment(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  async cloneBlueprint(event: Event, blueprint: Module) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit('cloneBlueprint', blueprint);
  }

  async archiveBlueprint(event: Event, blueprint: Module) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit('archiveBlueprint', blueprint);
  }

  async removeBlueprint(event: Event, blueprint: Module) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit('removeBlueprint', blueprint);
  }
}
